<template>
    <div>
        <el-row>
            <el-col :span="24" >
                <div class="show-title">
                    历年真题
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="20" :offset="2">
                <el-row v-if="list.length != 0">
                    <el-col :span="12" :xs="24" v-for="(item, index) in list" :key="index">
                        <div class="box-card" >
                            <el-card >
                                <el-row>
                                    <el-col :span="6">
                                        <img :src="source_prefix+item.img" alt="" style="width:100%">
                                    </el-col>
                                    <el-col :span="12" offset="2">
                                        <div class="category-name">{{item.category_name}}</div>
                                        <div class="work-count">
                                            <i class="el-icon-s-unfold"></i>
                                            {{item.work_count}} 套真题
                                         </div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="click-btn">
                                            <el-button type="primary" round @click="testStart(item)">立即答题</el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </div>
          
                    </el-col>
     
                </el-row>
                <el-row v-else>
                    <el-col>
                        <el-empty description="暂无数据" :image-size="300"></el-empty>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>

</script>


<script>
    import { realQuestionsCategoryList} from '@/api'
    import store from '@/store'
    export default {
        name: 'YearsList',
        props: ['cate', 'words'],
        data() {
            return {
                list:[],
                form:{

                },
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
            }
        },
        components: {
        },
        computed: {
        },
        methods: {
            realQuestionsCategoryList()
            {
                realQuestionsCategoryList(this.form).then(response => {
                    this.list = response
                })
            },
            testStart(e)
            {
                this.$router.push({path:'/realworklist',query: {category_id:e.category_id}})

            }
        },
        
        mounted() {
            this.form.id = this.$route.params.work_guid
            var res = "";
            this.realQuestionsCategoryList()
        }
    }
</script>
<style scoped lang="less">
    .show-title{
        font-size: 28px;
        text-align: center;
        padding: 3vh 0 3vh 0;
    }
    .box-card{
        padding:1vh;
    }
    .category-name{
        font-size:20px;
        color:#409EFF;
        margin-top:3vh;

    }
    .work-count{
        font-size: 20px;
        margin-top: 50px;
        color:#E6A23C
    }
    .click-btn{
        margin-top:120px;
    }
</style>
